(() => {
  setTimeout(() => {
    const slidecart = document.querySelector("#slidecarthq");
    const cartCount = document.querySelector(".js-header-cart-count");
    console.log(slidecart);

    slidecart.addEventListener("click", (e) => {
      const target = e.target;

      if (target.getAttribute("aria-label") === "decrease quantity") {
        console.log("decrease");
        cartCount.textContent = Number(cartCount.textContent) - 1;
      }

      if (target.getAttribute("aria-label") === "increase quantity") {
        console.log("increase");
        cartCount.textContent = Number(cartCount.textContent) + 1;
      }
    });
  }, 256);
})();
